<div mat-dialog-title>
  <app-scan-tag-input
    role="heading"
    placeholder="search a value"
    matInput
    [formControl]="searchCtrl"
  ></app-scan-tag-input>
</div>
<mat-dialog-content>
  <div class="touareg-control-dialog">
    <mat-selection-list #selectionList>
      <!-- <ng-container >
        <div *ngIf="byNew" class="mb-2">
          <mat-divider></mat-divider>
          <div class="mat-body-2 mr-1">
            New tag to add&nbsp;:
          </div>
          <mat-list-option
            [disabled]="disabled[byNew.tag_uid_tags_catalog]"
            [value]="{
              tag_uid_tags_catalog: byNew.tag_uid_tags_catalog
            }"
          >
            <div>#{{ byNew.tag_uid_tags_catalog }}</div>
          </mat-list-option>
        </div>
      </ng-container> -->
      <div *ngIf="byUid.length" class="mb-2">
        <mat-divider></mat-divider>
        <div class="mat-body-2 mr-1">
          Tag found by uid&nbsp;:
        </div>
        <mat-list-option
          [disabled]="disabled[byUid[0].pieces![0].tagIdentifier!]"
          [value]="{
            tag_uid_tags_catalog: byUid[0].pieces![0].tagIdentifier
          }"
        >
          <div>#{{ byUid[0].pieces![0].tagIdentifier }}</div>
        </mat-list-option>
      </div>
      <div *ngIf="byPairing.length">
        <mat-divider></mat-divider>
        <div class="mat-body-2 mr-1">
          Tag(s) found by pairing values&nbsp;:
        </div>
        <mat-list-option
          *ngFor="let item of byPairing"
          [value]="{
            tag_uid_tags_catalog: item.tag_uid_tags_catalog
          }"
          [disabled]="disabled[item.tag_uid_tags_catalog]"
        >
          <div>#{{ item.tag_uid_tags_catalog }}</div>
          <div class="text-small">
            {{ item.pairingField?.name }}&nbsp;: {{ item.pairingValue }}
          </div>
        </mat-list-option>
      </div>
    </mat-selection-list>
    <ng-container *ngIf="!byUid.length && !byPairing.length">
      <div *ngIf="!searchHasValue">
        Search by tag uid or by pairing value.
      </div>
      <div *ngIf="searchHasValue">No tags found.</div>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <button
    #submitBtn
    mat-button
    [disabled]="!selectionList.selectedOptions.selected.length"
    [mat-dialog-close]="selectionList.selectedOptions.selected"
  >
    Add
  </button>
</mat-dialog-actions>
